import axios from 'axios';
import moment from 'moment';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { reduxForm, Field, SubmissionError, formValueSelector } from 'redux-form';
import BlockUI from '../../../component/BlockUI';
import { RenderInputWithDiv, RenderHTMLSelect, RenderSelect, RenderCheckbox, RenderRadioCheckBox, RenderDatePicker } from '../../../component/formInput';
import { StringUtils } from '../../../utils/javascriptUtils';
var _ = require('lodash');

function getServerIpType(productType) {
  switch(productType) {
    case "EMAIL": {
      return "SERVER_EMAIL"
    }
    case "VPS" : {
      return "SERVER_VPS"
    }
    case "CLOUD_SERVER_PRO" : {
      return "SERVER_VPS"
    }
    case "CLOUD_BACKUP" : {
      return "SERVER_VPS"
    }
    case "LINUX_HOSTING" : {
      return "SERVER_CPANEL"
    }
    case "WINDOW_HOSTING" : {
      return "SERVER_PLESK"
    }
  }
}

const selector = formValueSelector("ItemRegisModal")

const validate = values => {
  const errors = {};
  if (!values.server_ip_address) {
    errors.server_ip_address = 'Vui lòng chọn Server.';
  }
  if (!values.password) {
    errors.password = 'Vui lòng nhập password.';
  }
  if (!values.dkim) {
    errors.dkim = 'Vui lòng nhập dkim.';
  }
  if (!values.email_domain_key) {
    errors.email_domain_key = 'Vui lòng nhập key.';
  }
  if (!values.ssl_key) {
    errors.ssl_key = 'Vui lòng nhập ssl key.';
  }
  if (!values.ssl_value) {
    errors.ssl_value = 'Vui lòng nhập ssl value.';
  }
  if (!values.expired_date) {
    errors.expired_date = 'Vui lòng chọn ngày hết hạn.';
  }
  return errors;
}

function VPSFormInput(server_ip_options) {
  return (
    <React.Fragment>
      <Field name="server_ip_address" label="Server IP" placeholder="Vui lòng Server IP..." options={server_ip_options} component={RenderSelect}></Field>
    </React.Fragment>
  )
}

function EmailFormInput(server_ip_options) {
  return (
    <React.Fragment>
      <Field name="server_ip_address" label="Server IP" placeholder="Vui lòng Server IP..." options={server_ip_options} component={RenderSelect}></Field>
      <Field name="password" label="Mật Khẩu" placeholder="Vui lòng nhập mật khẩu..." component={RenderInputWithDiv}></Field>
      <Field name="email_domain_key" label="ID" placeholder="Vui nhập ID cho email..." component={RenderInputWithDiv}></Field>
      <Field name="dkim" label="DKIM" placeholder="Vui nhập DKIM cho email..." component={RenderInputWithDiv}></Field>
    </React.Fragment>
  )
}

function CloudBackupDelivery(server_ip_options) {
  return (
    <React.Fragment>
      <Field name="server_ip_address" label="Server IP" placeholder="Vui lòng Server IP..." options={server_ip_options} component={RenderSelect}></Field>
    </React.Fragment>
  )
}

function HostingDelivery(server_ip_options) {
  return (
    <React.Fragment>
      <Field name="server_ip_address" label="Server IP" placeholder="Vui lòng Server IP..." options={server_ip_options} component={RenderSelect}></Field>
    </React.Fragment>
  )
}

function SSLDelivery() {
  return (
    <React.Fragment>
      <Field name="ssl_key" label="Host Name" placeholder="Vui lòng nhập tên miền hoặc @..." component={RenderInputWithDiv}></Field>
      <Field name="ssl_value" label="SSL Value (Content)" placeholder="Vui lòng nhập..." component={RenderInputWithDiv}></Field>
    </React.Fragment>
  )
}

function DomainFormInput(provider_option) {
  return (
    <React.Fragment>
      <Field defaultValue="NH" name="domain_provider"  label="Nhà Cung Cấp" options={provider_option} component={RenderHTMLSelect}></Field>
    </React.Fragment>
  )
}

// Form Đăng Ký Taduphone.
function TaduphoneFormInput() {
  return (
    <React.Fragment>
      <Field name="phone_number" label="Số Tổng Đài" placeholder="Nhập số tổng đài đăng ký..." component={RenderInputWithDiv}></Field>
    </React.Fragment>
  )
}

function TransferDomainFormInput(provider_option) {
  return (
    provider_option.length > 0 && <React.Fragment>
      <Field 
        name="domain_provider" 
        isLabelTop={true} 
        label="Nhà Cung Cấp" 
        defaultValue="NH"
        options={provider_option} 
        component={RenderHTMLSelect}
      />
      <Field 
        name="expired_date" 
        isLabelTop={true} 
        label="Ngày hết hạn hiện tại (Trước khi Transfer)"  
        placeholder="dd/mm/yyyy" 
        dateFormat="dd/MM/yyyy" 
        component={RenderDatePicker}></Field>
    </React.Fragment>
  )
}  

class ItemRegisModal extends React.Component {
  intervalVPSAutoSetupTask;
  constructor(props) {
    super(props);
    this.state = {
      server_ip_address_data: [],
      setup_type: null,
      isLoading: false,
      vpsTaskProgress: null
    }

  }

  SetupService = (setup_type) => {
    this.setState({
      setup_type: setup_type
    })
  }
  getIPServerList() {
    const {invoice_item_obj} = this.props;
    const product_type = invoice_item_obj.product.product_type;
    const self = this;
    axios({
      method: 'get',
      url: window.api_url + '/admin/api/ip_server/' + getServerIpType(product_type),
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        self.setState({
          server_ip_address_data: response.data.data
        })
      }
    });
  }

  componentDidMount() {
    this.getIPServerList();
  }


  componentWillUnmount() {
    /*
      stop Load status from continuing to run even
      after unmounting this component. Notice we are calling
      'clearTimeout()` here rather than `clearInterval()` 
    */
    clearTimeout(this.intervalVPSAutoSetupTask);
    this.setState({
      vpsTaskProgress: null
    })
  }

  // Tạo thông tin đăng nhập cho dịch vụ Cloud Backup
  cloudBackupDelivery(values) {
    const {customer_id, invoice_item_obj, invoice_code} = this.props;
    return {
      customer_id: customer_id,
      invoice_code: invoice_code,
      invoice_item_id: invoice_item_obj.id,
      item_month: invoice_item_obj.month, 
      item_extra_month: invoice_item_obj.extra_month,
      product_id: invoice_item_obj.product_id,
      domain: null,
      server_ip_address: values.server_ip_address,
      ip_address: null,
      backup_ip_address: null,
      status: "PENDING",
      domain_profile_id: null,
      auto_renew: false
    }
  }

  // Khởi tạo đơn hàng tên miền
  domainDeliveryObject(values) {
    const {customer_id, invoice_item_obj, invoice_code} = this.props;
    return {
      customer_id: customer_id,
      invoice_code: invoice_code,
      invoice_item_id: invoice_item_obj.id,
      item_month: invoice_item_obj.month, 
      item_extra_month: invoice_item_obj.extra_month,
      product_id: invoice_item_obj.product_id,
      domain: invoice_item_obj.domain,
      server_ip_address: null,
      ip_address: null,
      backup_ip_address: null,
      status: "RUNNING",
      domain_profile_id: invoice_item_obj.domain_profile_id,
      auto_renew: false,
      domain_provider: values.domain_provider
    }
  }

  // Khởi tạo đơn hàng VPS
  vpsDeliveryObject(values) {
    const {customer_id, invoice_item_obj, invoice_code} = this.props;
    return {
      customer_id: customer_id,
      invoice_code: invoice_code,
      invoice_item_id: invoice_item_obj.id,
      item_month: invoice_item_obj.month, 
      item_extra_month: invoice_item_obj.extra_month,
      product_id: invoice_item_obj.product_id,
      domain: null,
      server_ip_address: values.server_ip_address,
      ip_address: null, // Ip_address Gen ra từ danh sách IP "Chưa có dịch vụ sử dụng"
      backup_ip_address: null,
      status: "PENDING",
      domain_profile_id: null,
      template_id: invoice_item_obj.template_id,
      auto_renew: false
    }
  }

  // Khởi tạo đơn hàng Hosting.
  hostingDeliveryObject(values) {
    const {customer_id, invoice_item_obj, invoice_code} = this.props;
    return {
      customer_id: customer_id,
      invoice_code: invoice_code,
      invoice_item_id: invoice_item_obj.id,
      item_month: invoice_item_obj.month, 
      item_extra_month: invoice_item_obj.extra_month,
      product_id: invoice_item_obj.product_id,
      domain: invoice_item_obj.domain,
      server_ip_address: values.server_ip_address,
      ip_address: values.server_ip_address, 
      backup_ip_address: null,
      status: "PENDING",
      domain_profile_id: null,
      template_id: null,
      auto_renew: false
    }
  }

  // Khởi tạo đơn hàng EMAIL.
  emailDeliveryObject(values) {
    const {customer_id, invoice_item_obj, invoice_code} = this.props;
    return {
      customer_id: customer_id,
      invoice_code: invoice_code,
      invoice_item_id: invoice_item_obj.id,
      item_month: invoice_item_obj.month, 
      item_extra_month: invoice_item_obj.extra_month,
      product_id: invoice_item_obj.product_id,
      username: null,
      password: values.password,
      domain: invoice_item_obj.domain,
      server_ip_address: values.server_ip_address,
      ip_address: values.server_ip_address,
      backup_ip_address: null,
      status: "RUNNING",
      dkim: values.dkim,
      email_domain_key: values.email_domain_key,
      domain_profile_id: null,
      template_id: null,
      auto_renew: false
    }
  }

  // Khởi tạo đơn hàng SSL.
  sslDeliveryObject(values) {
    const {customer_id, invoice_item_obj, invoice_code} = this.props;
    return {
      customer_id: customer_id,
      invoice_code: invoice_code,
      invoice_item_id: invoice_item_obj.id,
      item_month: invoice_item_obj.month, 
      item_extra_month: invoice_item_obj.extra_month,
      product_id: invoice_item_obj.product_id,
      domain: invoice_item_obj.domain,
      server_ip_address: null,
      ip_address: null, 
      backup_ip_address: null,
      status: "RUNNING",
      ssl_key: values.ssl_key,
      ssl_value: values.ssl_value,
      domain_profile_id: null,
      template_id: null,
      auto_renew: false
    }
  }

  // Khởi tạo đơn hàng TADUPHONE.
  taduphoneDeliveryObject(values) {
    const {customer_id, invoice_item_obj, invoice_code} = this.props;
    return {
      customer_id: customer_id,
      invoice_item_id: invoice_item_obj.id,
      invoice_code: invoice_code,
      item_month: invoice_item_obj.month, 
      item_extra_month: invoice_item_obj.extra_month,
      product_id: invoice_item_obj.product_id,
      // số tổng đài đăng ký.
      domain: values.phone_number,
      server_ip_address: null,
      ip_address: null,
      backup_ip_address: null,
      status: "PENDING",
      domain_profile_id: null,
      template_id: null,
      auto_renew: false
    }
  }
  
  // Khởi tạo đơn hàng TaduInvoice (Hoá đơn điện tử).
  taduInvoiceDeliveryObject() {
    const {customer_id, invoice_item_obj, invoice_code} = this.props;
    return {
      customer_id: customer_id,
      invoice_code: invoice_code,
      invoice_item_id: invoice_item_obj.id,
      item_month: invoice_item_obj.month, 
      item_extra_month: invoice_item_obj.extra_month,
      product_id: invoice_item_obj.product_id,
      domain: null,
      server_ip_address: null,
      ip_address: null,
      backup_ip_address: null,
      status: "RUNNING",
      domain_profile_id: null,
      template_id: null,
      auto_renew: false
    }
  }

  // Khởi tạo đơn hàng TaduInvoice (Hoá đơn điện tử).
  digitalSignatureObject() {
    const {customer_id, invoice_item_obj, invoice_code} = this.props;
    return {
      customer_id: customer_id,
      invoice_item_id: invoice_item_obj.id,
      invoice_code: invoice_code,
      item_month: invoice_item_obj.month, 
      item_extra_month: invoice_item_obj.extra_month,
      product_id: invoice_item_obj.product_id,
      domain: null,
      server_ip_address: null,
      ip_address: null,
      backup_ip_address: null,
      status: "RUNNING",
      domain_profile_id: invoice_item_obj.domain_profile_id,
      template_id: null,
      auto_renew: false
    }
  }

  // Xác nhận transfer cho tên miền.
  transferDomainObject(values) {
    const {customer_id, invoice_item_obj, invoice_code} = this.props;
    return {
      customer_id: customer_id,
      invoice_code: invoice_code,
      invoice_item_id: invoice_item_obj.id,
      item_month: invoice_item_obj.month, 
      item_extra_month: invoice_item_obj.extra_month,
      product_id: invoice_item_obj.product_id,
      domain: invoice_item_obj.domain,
      server_ip_address: null,
      ip_address: null,
      backup_ip_address: null,
      status: "PENDING_TRANSFER",
      domain_profile_id: invoice_item_obj.domain_profile_id,
      auto_renew: false,
      domain_provider: values.domain_provider,
      expired: moment(values.expired_date).format(`YYYY-MM-DD 00:00:00`)
    }
  }

  regisIPAddonService = () => {
    const {customer_id, invoice_item_obj, onHide, invoice_code} = this.props;
    const self = this;
    // BlockPage and waiting method post response
    this.setState({
      isLoading: true
    })
    const body_object = {
      customer_id: customer_id,
      invoice_code: invoice_code,
      invoice_item_id: invoice_item_obj.id,
      product_id: invoice_item_obj.product_id,
      quantity: invoice_item_obj.quantity,
    }
    axios({
      method: 'post',
      url: window.api_url + '/admin/api/setup/regis/ip/addon/invoice',
      withCredentials: true,
      data: body_object
    }).then(function (response) {
      self.setState({
        isLoading: false
      })
      if(!response.data.isError) {
        onHide();
      }else {
        toast.error(response.data.error)
      }
    });
  }

  regisWhoIsAddonService = () => {
    const {customer_id, invoice_item_obj, onHide, invoice_code} = this.props;
    const self = this;
    // BlockPage and waiting method post response
    this.setState({
      isLoading: true
    })
    const body_object = {
      customer_id: customer_id,
      invoice_code: invoice_code,
      invoice_item_id: invoice_item_obj.id
    }
    axios({
      method: 'post',
      url: window.api_url + '/admin/api/setup/regis/whois/addon/invoice',
      withCredentials: true,
      data: body_object
    }).then(function (response) {
      self.setState({
        isLoading: false
      })
      if(!response.data.isError) {
        onHide();
      }else {
        toast.error(response.data.error)
      }
    });
  }

  manualDeliveryService = (submitted_values) => {
    const {onHide, invoice_item_obj} = this.props;
    const product_type = invoice_item_obj.product.product_type;
    const self = this;
    // BlockPage and waiting method post response
    this.setState({
      isLoading: true
    })
    let body_object = null;
    let url = "/admin/api/setup/regis/invoice";
    // Đối với các dịch vụ VPS, Hosting, Cloudbackup, Taduphone cần phải khởi tạo thông tin Đăng nhập trước.
    if(["VPS","CLOUD_SERVER_PRO", "LINUX_HOSTING", "WINDOW_HOSTING", "CLOUD_BACKUP", "TADU_PHONE"].includes(product_type)) {
      url = "/admin/api/create/service/info";
    } 
    // Kiểm tra product_type và get đúng body_object theo từng loại đơn hàng.
    if(["VPS", "CLOUD_SERVER_PRO"].includes(product_type)) {
      body_object = this.vpsDeliveryObject(submitted_values)
    }
    if(product_type == "IP") {
      this.regisIPAddonService();
    }
    if(product_type == "WHOIS_PRIVACY") {
      this.regisWhoIsAddonService();
    }
    // Dành cho tên miền đăng ký mới và gia hạn
    if(!invoice_item_obj.is_tranfer && ["VN_DOMAIN", "COM_DOMAIN"].includes(product_type)) {
      body_object = this.domainDeliveryObject(submitted_values);
    }
    // Dành cho tên miền transfer
    if(invoice_item_obj.is_tranfer && ["COM_DOMAIN"].includes(product_type)) {
      body_object = this.transferDomainObject(submitted_values);
    }
    if(["LINUX_HOSTING", "WINDOW_HOSTING"].includes(product_type)) {
      body_object = this.hostingDeliveryObject(submitted_values)
    }
    if(product_type == "EMAIL") {
      body_object = this.emailDeliveryObject(submitted_values)
    }
    if(product_type == "SSL") {
      body_object = this.sslDeliveryObject(submitted_values)
    }
    if(product_type == "TADU_PHONE") {
      body_object = this.taduphoneDeliveryObject(submitted_values)
    }
    if(product_type == "CLOUD_BACKUP") {
      body_object = this.cloudBackupDelivery(submitted_values)
    }
    if(product_type == "TADU_INVOICE") {
      body_object = this.taduInvoiceDeliveryObject(submitted_values)
    }
    if(product_type == "DIGITAL_SIGNATURE") {
      body_object = this.digitalSignatureObject(submitted_values)
    }

    if(body_object != null) {
      axios({
        method: 'post',
        url: window.api_url + url,
        withCredentials: true,
        data: body_object
      }).then(function (response) {
        self.setState({
          isLoading: false
        })
        if(!response.data.isError) {
          onHide();
        }else {
          toast.error(response.data.error);
        }
      });
    }
  }

  // Khởi tạo dịch vụ tự động.
  autoDeliveryService = (formValue, productType) => {
    if(["VPS", "CLOUD_SERVER_PRO"].includes(productType)) {
      this.vpsAutoSetup();
    }
    if(["SSL"].includes(productType)) {
      this.sslAutoSetup();
    }
    if(["EMAIL"].includes(productType)) {
      this.emailAutoSetup();
    }
  }

  // Khởi tạo VPS Tự động.
  vpsAutoSetup() {
    const {customer_id, invoice_item_obj, invoice_code} = this.props;
    const alert_confirm = window.confirm("Bạn có chắc sẽ khởi tạo tự động dịch vụ Cloud Server ?.");
    const self = this;
    const body_object = {
      customer_id: customer_id,
      invoice_code: invoice_code,
      invoice_item_id: invoice_item_obj.id,
      item_month: invoice_item_obj.month, 
      item_extra_month: invoice_item_obj.extra_month,
      product_id: invoice_item_obj.product_id,
      status: "RUNNING",
      template_id: invoice_item_obj.template_id,
      auto_renew: false
    }

    if(alert_confirm) {
      // BlockPage and waiting method post response
      this.setState({
        isLoading: true
      })
      axios({
        method: 'post',
        url: window.api_url + '/admin/api/vps/auto_regis',
        withCredentials: true,
        data: body_object
      }).then(function (response) {
        if(!response.data.isError) {
          self.sendServiceAutoSetupInfo(response.data.data)
        }else {
          self.setState({
            isLoading: false
          })
          toast.error(response.data.error);
        }
      });
    }
  }

  // Khởi tạo SSL Tự động.
  sslAutoSetup() {
    const {invoice_item_obj, invoice_code, onHide} = this.props;
    const alert_confirm = window.confirm("Bạn có chắc sẽ khởi tạo tự động dịch vụ SSL ?.");
    const self = this;
    const body_object = {
      invoice_code: invoice_code,
      invoice_item_id: invoice_item_obj.id,
    }
    
    if(alert_confirm) {
      // BlockPage and waiting method post response
      this.setState({
        isLoading: true
      })
      axios({
        method: 'post',
        url: window.api_url + '/admin/api/ssl/auto_regis',
        withCredentials: true,
        data: body_object
      }).then(function (response) {
        self.setState({
          isLoading: false
        })
        if(!response.data.isError) {
          onHide();
        }else {
          toast.error(response.data.error);
        }
      });
    }
  }

  // Khởi tạo Email Tự động.
  emailAutoSetup() {
    const {invoice_item_obj, invoice_code, onHide} = this.props;
    const alert_confirm = window.confirm("Bạn có chắc sẽ khởi tạo tự động dịch vụ Email ?.");
    const self = this;
    const body_object = {
      invoice_code: invoice_code,
      invoice_item_id: invoice_item_obj.id,
    }
    
    if(alert_confirm) {
      // BlockPage and waiting method post response
      this.setState({
        isLoading: true
      })
      axios({
        method: 'post',
        url: window.api_url + '/admin/api/email/auto_regis',
        withCredentials: true,
        data: body_object
      }).then(function (response) {
        self.setState({
          isLoading: false
        })
        if(!response.data.isError) {
          onHide();
        }else {
          toast.error(response.data.error);
        }
      });
    }
  }

  sendServiceAutoSetupInfo(data) {
    const { onHide } = this.props;
    const self = this;
   
    return axios({
      method: 'post',
      url: window.api_url+ "/admin/api/vps/send_service_auto_setup_info",
      data: data,
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError && response.data.data.progress === "100") {
        onHide();
        self.setState({
          isLoading: false,
          vpsTaskProgress: null
        })
        clearTimeout(self.intervalVPSAutoSetupTask)
      }else if(!response.data.isError) {
        self.setState({
          vpsTaskProgress: response.data.data.progress
        })
        self.intervalVPSAutoSetupTask = setTimeout(self.sendServiceAutoSetupInfo.bind(self, data), 10000);
      }else {
        self.intervalVPSAutoSetupTask = setTimeout(self.sendServiceAutoSetupInfo.bind(self, data), 10000);
      }
    })
  }

  render() {
    const { server_ip_address_data, isLoading, vpsTaskProgress } = this.state;
    const { handleSubmit, invoice_item_obj, setupTypeSelected  } = this.props;
    const modalConfig = { backdrop: 'static', show: this.props.show, bssize: "medium", onHide: this.props.onHide, keyboard: false };
    const product_type = invoice_item_obj.product.product_type;
    const setup_type_options = [
      { label:"Khởi tạo thủ công", value: "MANUAL_SERVICE_SETUP" },
      { label:"Khởi tạo tự động", value:"AUTO_SERVICE_SETUP" }
    ];
    const provider_option = [
      {label: "Nhân Hòa", value: "NH"},
      {label: "Pa Việt Nam", value: "PA"},
      {label: "Realtime", value: "RT", disabled: product_type == "VN_DOMAIN" && true},
      {label: "Resello", value: "RS", disabled: product_type == "VN_DOMAIN" && true}
    ]
    const server_ip_options = _.map(server_ip_address_data, (i) => ({label: `${i.ip} ${i.group_name ? i.group_name : ""}`  , value: i.ip }))
    return (
      <div style={{ width: '30%' }}>
        <ToastContainer />
        <Modal
          {...modalConfig}
          aria-labelledby="contained-modal-title-lg">
          <Modal.Header closeButton={!isLoading && true}>
            <Modal.Title id="contained-modal-title-sm"><center>Khởi tạo đơn hàng</center> </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {isLoading && <div>
                <img width="30" src="/assets/img/squares.gif" />
                {vpsTaskProgress && <span>Đang tiến hành khởi tạo VPS tự động {vpsTaskProgress} % ...  </span>}
              </div>}
            {!isLoading && <form className="form-horizontal">
              <Field name="setup_type" options={setup_type_options} component={RenderRadioCheckBox} />
              {/* USE FOR MANUAL SERVICE SETUP */}
                {setupTypeSelected == "MANUAL_SERVICE_SETUP" && 
                  <React.Fragment>
                    {["VPS", "CLOUD_SERVER_PRO"].includes(product_type) && VPSFormInput(server_ip_options)}
                    {product_type == "EMAIL" && EmailFormInput(server_ip_options)}
                    {product_type == "CLOUD_BACKUP" && CloudBackupDelivery(server_ip_options)}
                    {["LINUX_HOSTING", "WINDOW_HOSTING"].includes(product_type) && HostingDelivery(server_ip_options)}
                    {product_type == "SSL" && SSLDelivery()}
                    {/* Dành cho tên miền đăng ký mới*/}
                    {!invoice_item_obj.is_tranfer && ["VN_DOMAIN", "COM_DOMAIN"].includes(product_type) && DomainFormInput(provider_option)}
                    {/* Dành cho tên miền Transfer*/}
                    {invoice_item_obj.is_tranfer && ["COM_DOMAIN"].includes(product_type) && TransferDomainFormInput(provider_option)}
                    {/* Đăng ký mới TADUPHONE */}
                    {product_type == "TADU_PHONE" && TaduphoneFormInput()}
                    <button type="submit" onClick={handleSubmit(this.manualDeliveryService)} style={{margin: 5, float: 'right'}} className={"btn bg-orange btn-orange"}>
                      Lưu
                    </button>
                  </React.Fragment>}
                {setupTypeSelected == "AUTO_SERVICE_SETUP" && 
                  <React.Fragment>
                    <button type="submit" onClick={handleSubmit((value) => this.autoDeliveryService(value, product_type))} style={{margin: 5, float: 'right'}} className={"btn bg-orange btn-orange"}>
                      Lưu
                    </button>
                  </React.Fragment>}
            </form>}
          </Modal.Body>
        </Modal>
      </div>
    )
  }
};
const mapState = (state, props) => ({
  initialValues: {
    ...props.invoiceObject
  },
  userProfile: state.userProfile.data,
  setupTypeSelected: selector(state, "setup_type"),
});

const mapDispatch = dispatch => ({
  
});

export default (connect(mapState, mapDispatch)(
  reduxForm({
    form: 'ItemRegisModal',
    destroyOnUnmount: true,
    enableReinitialize: true,
    validate
  })(withRouter(ItemRegisModal))));




